import { useTimeZones } from '@bizzabo/entities';
import { useAtomValue } from 'jotai';

import currentTimeZoneIdAtom from '../timeZoneId';

const useSchedulingTimeZone = () => {
    const timeZoneId = useAtomValue(currentTimeZoneIdAtom);
    const timeZonesQuery = useTimeZones();
    const tzData = timeZonesQuery.data?.find(({ name }) => name === timeZoneId);

    return {
        data: tzData,
        isLoading: timeZonesQuery.isLoading,
    };
};

export default useSchedulingTimeZone;
